export default __webpack_public_path__ + "static/media/INTEGRIDAD.fabed81d.jpg";